import { useApi } from '#shared/providers/Api';
import useUsers from '../useUsers';
import unwrap from '../unwrap';

export default function useCreateUser() {
  const api = useApi();
  const { account } = useUsers();

  function createUser(params: { EmailAddress: string; SendEmail: boolean }) {
    return unwrap(api.postCreateAccountUser(params, account.bearer));
  }

  return { createUser };
}
